import { TimeQuestionConfig, TimeResponseState } from '@gripp/shared-logic';
import { useTranslation } from 'react-i18next';
import { View } from 'react-native';
import { Text } from 'react-native-paper';
import {
  RoutineQuestionMessage,
  RoutineQuestionMessageProps,
} from '../../types';

export const DateOnlyMessage: RoutineQuestionMessage<
  TimeQuestionConfig,
  TimeResponseState
> = (
  props: RoutineQuestionMessageProps<TimeQuestionConfig, TimeResponseState>
) => {
  const { t } = useTranslation();
  const { response } = props;
  const date =
    typeof response.timeTypeValue === 'string' ? response.timeTypeValue : '-';
  return (
    <View>
      <Text style={props.textStyle}>
        {t('routines.time.message.date')}: {date}
      </Text>
    </View>
  );
};
